module.exports = __webpack_public_path__ + "img/30cee91b7054480f96a9e42ca4977c33-640.c238770d.jpg";